import { render, staticRenderFns } from "./SearchChannelTypesDropdown.vue?vue&type=template&id=437154b8&scoped=true&"
import script from "./SearchChannelTypesDropdown.vue?vue&type=script&lang=js&"
export * from "./SearchChannelTypesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SearchChannelTypesDropdown.vue?vue&type=style&index=0&id=437154b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437154b8",
  null
  
)

export default component.exports